import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {ReactiveTable} from "react-ive-tables";
import {useDialog} from "../../../lib/hooks/useDialog";
import {useConfirmDialog} from "../../../lib/hooks/useConfirmDialog";
import {useToast} from "../../../lib/hooks/useToast";
import {Api, UserDTO} from "../../../lib/services/mainApi";
import {ComponentContainer} from "../../../lib/templates/ComponentContainer";
import {Button} from "primereact/button";
import CreateOrUpdateUser from "./form/CreateOrUpdateUser";
import moment from "moment";
import CSVDialog from "./CSVDialog";
import ReportDialog from "./ReportDialog";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import ReportDialogV2 from "./ReportDialogV2";

interface Props {

}


const Users: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const {showDialog, hideDialog} = useDialog();
    const {showConfirmDialog} = useConfirmDialog();
    const {showToast} = useToast();
    const api = new Api();

    const [users, setUsers] = useState<UserDTO[]>();
    const [selectedUser, setSelectedUser] = useState<UserDTO>();
    const [selectedOperation, setSelectedOperation] = useState<"edit" | "delete">();


    const loadUsers = () => {
        api.api.adminV1UserAllList()
            .then(resp => {
                if (resp.data && resp.data.users)
                    setUsers(resp.data.users)
            })
    }

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        loadUsers();
    }, []);

    useEffect(() => {
        switch (selectedOperation) {
            case 'edit': {
                showCreateOrUpdateUserDialog();
            }

        }
    }, [selectedOperation])

    const getHeaderButtons = () => {
        return [
            {
                onClick: () => showCreateOrUpdateUserDialog(),
                icon: 'pi pi-plus',
                className: '',
                tooltipLabel: f({id: "create"})
            },
            {
                onClick: () => exportCsv(),
                icon: 'pi pi-file-excel',
                className: 'ml-2 p-button-success',
                tooltipLabel: f({id: "exportCsv"})
            },
            {
                onClick: () => handleReportV2(),
                icon: 'pi pi-chart-bar',
                className: 'ml-2 p-button-success',
                tooltipLabel: f({id: "report"})
            }
        ]
    }

    const exportCsv = () => {
        showDialog({
            newContent: <CSVDialog />,
            heading: f({id: "exportCsv"})
        })
        // api.api.adminV1GetcsvCreate()
        //     .then()
    }

    // const handleReport = () => {
    //     showDialog({
    //         newContent: <ReportDialog usernameOptions={users!.map(user => {
    //             return {
    //                 description: user.username,
    //                 key: user.id,
    //                 id: user.username
    //             } as IDropdownOption
    //         })}/>,
    //         heading: f({id: "report"}),
    //         style: {maxWidth: "80vw"}
    //     })
    // }

    const handleReportV2 = () => {
        showDialog({
            newContent: <ReportDialogV2 usernameOptions={users!.map(user => {
                return {
                    description: user.username,
                    key: user.id,
                    id: user.id
                } as IDropdownOption
            })}/>,
            heading: f({id: "report"}),
            style: {maxWidth: "80vw"}
        })
    }

    const showCreateOrUpdateUserDialog = (selectedUser?: UserDTO) => {
        showDialog({
            newContent: <CreateOrUpdateUser selectedUser={selectedUser || undefined} createdCb={() => {
                hideDialog();
                loadUsers();
            }}/>,
            heading: <h3>{f({id: selectedUser ? "updateUser" : "createUser"})}</h3>,
            style: {maxWidth: "80vw", minWidth: "60vw"},
            onHideCallback: () => {
                setSelectedUser(undefined);
                setSelectedOperation(undefined)
            }
        })
    }

    const getColumnTemplate = () => {
        return {
            operations: (rowData: UserDTO) => {
                return <div className={"flex justify-content-between"}>
                    <Button icon={"pi pi-pencil"} severity={"warning"} onClick={() => {
                        showCreateOrUpdateUserDialog(rowData)
                    }}/>
                    <Button icon={"pi pi-trash"} severity={"danger"} onClick={() => handleDelete(rowData)}/>
                </div>
            },
            created: (rowData: UserDTO) => moment(rowData.created).local().format('YYYY-MM-DD HH:mm:ss'),
            lastLogged: (rowData: UserDTO) => rowData.lastLogged ? moment(rowData.lastLogged).local().format('YYYY-MM-DD HH:mm:ss') : f({id: "noDate"})
        }
    }

    const handleDelete = (rowData: UserDTO) => {
        showConfirmDialog({body: f({id: "confirmDeleteUser"}, {username: rowData.username})}).then(answer => {
            if (answer) {
                api.api.adminV1UserDelete(rowData.id!).then(() => {
                    showToast("success", "", f({id: "successfullyDeletedUser"}));
                    loadUsers();
                });
            }
            setSelectedOperation(undefined);

        })
    }


    return <ComponentContainer componentName={f({id: "users"})}>
        <ReactiveTable
            data={users}
            totalRecords={users?.length || 0}
            setSelected={setSelectedUser}
            selectedIds={[selectedUser?.id!]}
            showHeader={true}
            selectionKey={"id"}
            selectionMode={"single"}
            headerButtons={getHeaderButtons()}
            columnTemplate={getColumnTemplate()}
            ignoreFilters={["operations"]}
            columnOrder={['username', 'locationTag', 'created', 'lastLogged', 'isDeleted', 'operations']}
        />
    </ComponentContainer>
};

export default Users
